var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 84,
    viewBox: "0 0 146 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_27615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.501 55.9373C132.501 69.5498 121.271 80.5836 107.417 80.5836C93.5626 80.5836 82.333 69.5498 82.333 55.9373C82.333 42.3264 93.5626 31.291 107.417 31.291C121.271 31.291 132.501 42.3264 132.501 55.9373Z",
    fill: "#8950FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3333 108.749C82.3333 132.084 63.0809 151 39.3324 151C15.5854 151 -3.66699 132.084 -3.66699 108.749C-3.66699 85.415 15.5854 66.5 39.3324 66.5C63.0809 66.5 82.3333 85.415 82.3333 108.749Z",
    fill: "#8950FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0019 17.2094C68.0019 36.6547 51.9579 52.4188 32.1674 52.4188C12.377 52.4188 -3.66699 36.6547 -3.66699 17.2094C-3.66699 -2.23587 12.377 -18 32.1674 -18C51.9579 -18 68.0019 -2.23587 68.0019 17.2094Z",
    fill: "#8950FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.334 3.12468C168.334 14.7918 158.707 24.2494 146.833 24.2494C134.958 24.2494 125.333 14.7918 125.333 3.12468C125.333 -8.54249 134.958 -18 146.833 -18C158.707 -18 168.334 -8.54249 168.334 3.12468Z",
    fill: "#8950FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.417 6.64552C107.417 12.4799 102.604 17.2087 96.6665 17.2087C90.7302 17.2087 85.9175 12.4799 85.9175 6.64552C85.9175 0.81274 90.7302 -3.91602 96.6665 -3.91602C102.604 -3.91602 107.417 0.81274 107.417 6.64552Z",
    fill: "#8950FC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_27615"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H134C140.627 0 146 5.37258 146 12V72C146 78.6274 140.627 84 134 84H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape3.6e328e875a9d0b2ed28ca5bba2a95441.svg";
export { ForwardRef as ReactComponent };